module.exports = __webpack_public_path__ + "img/arrow-right.c1cd3ddf.svg";